'use client';

import { VpIcon } from '@vtmn-play/react';
import useConfig from '@/hooks/useConfig';
import WidgetCategoryItem from './WidgetCategoryItem';
import { useTranslations } from 'next-intl';
import StepContainer from '../StepContainer/StepContainer';
import { useWidgetStore } from '@/providers/widget.provider';
import { Session } from 'next-auth';
import { BookingCountryService, Category } from '@repo/common/interfaces';
import Callout from '@repo/ui/Callout';

import './WidgetCategoryStep.scss';

interface WidgetCategoryStepProps {
  session: Session | null;
  categories?: Category<BookingCountryService>[];
}

const WidgetCategoryStep = ({
  session,
  categories,
}: WidgetCategoryStepProps) => {
  const t = useTranslations('Widget.pages.steps.categories.content');
  const { goToNextStep } = useConfig();
  const { setCategoryType } = useWidgetStore((state) => state);

  const handleCategoryOnClick = (category: Category<BookingCountryService>) => {
    setCategoryType(category.type);
    goToNextStep(session, {
      category: category?.type,
    });
  };

  return (
    <StepContainer className='widget-categories-step'>
      {categories?.length === 0 && (
        <div className='flex flex-col items-center justify-center'>
          <VpIcon name='warning-error' />
          <p className='text-center vp-body-s'>{t('empty')}</p>
        </div>
      )}

      {t.has('information') && (
        <Callout className='mbe-4' icon='information'>
          {t('information')}
        </Callout>
      )}

      <ul>
        {categories?.map((category: Category<BookingCountryService>) => (
          <li key={category?.type}>
            <WidgetCategoryItem
              onClick={() => handleCategoryOnClick(category)}
              category={category}
            />
          </li>
        ))}
      </ul>
    </StepContainer>
  );
};

export default WidgetCategoryStep;
